import React, { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";

const flags = [
  "https://cdn.jiro.build/Random/1.svg",
  "https://cdn.jiro.build/Random/2.svg",
  "https://cdn.jiro.build/Random/3.svg",
  "https://cdn.jiro.build/Random/4.svg",
  "https://cdn.jiro.build/Random/5.svg",
  "https://cdn.jiro.build/Random/6.svg",
  "https://cdn.jiro.build/Random/7.svg",
  "https://cdn.jiro.build/Random/8.svg",
  "https://cdn.jiro.build/Random/9.svg",
  "https://cdn.jiro.build/Random/10.svg",
  "https://cdn.jiro.build/Random/11.svg",
  "https://cdn.jiro.build/Random/12.svg",
  "https://cdn.jiro.build/Random/13.svg",
  "https://cdn.jiro.build/Random/14.svg",
  "https://cdn.jiro.build/Random/15.svg"
];

export default function TrustedCountries() {
  const shouldReduceMotion = useReducedMotion();
  const containerRef = useRef(null);
  
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"]
  });

  const x = useTransform(scrollYProgress, [0, 1], ["100vw", "0vw"]);
  const rotateFlags = useTransform(scrollYProgress, [0, 1], ["0deg", "-360deg"]);

  return (
    <div className="w-full overflow-hidden flex justify-end pt-[48px] pb-[0px]">
      <motion.div 
        ref={containerRef}
        style={{ 
          x: shouldReduceMotion ? 0 : x, 
        }}
        className="flex flex-nowrap p-[16px] items-center gap-[16px] rounded-l-full rounded-r-none bg-[#0D211D] w-max mb-[40px] md:mb-[60px]"
      >
        {flags.map((f, i) => (
          <div 
            key={i} 
            className="w-[64px] h-[64px] md:w-[88px] md:h-[88px] rounded-full bg-[#1a3832] flex items-center justify-center flex-shrink-0 relative overflow-hidden"
          >
            <motion.img 
              src={f} 
              alt="Flag" 
              className="w-full h-full object-cover" 
              style={{ 
                rotate: shouldReduceMotion ? 0 : rotateFlags,
              }}
              referrerPolicy="no-referrer" 
            />
          </div>
        ))}
      </motion.div>
    </div>
  )
}